import $ from 'jquery'

$( document ).ready(function() {
    $('a[href="#"]').click(function(e) {
        e.preventDefault();
    })
    const getCookieValue = (name) => {
        const substrings = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
        if( !substrings ) return ""
        return substrings.pop();
    }
    const removeSlash = (string) => {
        return string.replace(/\/$/, '')
    }
    const languageLinks = document.querySelectorAll('.site-header .wpml-ls-link');
    languageLinks.forEach((link) => {
        link.setAttribute('href', link.getAttribute('href') + "?language-changed=1");
    });
    const urlParams = new URLSearchParams(window.location.search);
    let url_param = urlParams.get('language-changed');
    if(url_param != null) {
        localStorage.setItem('sitelang-r', getCookieValue('wp-wpml_current_language'));
        window.history.replaceState({}, document.title, window.location.href.replace('?language-changed=1', ''));
    }
    let sitelang_redirected_value = getCookieValue('sitelang_redirected').toString() === '1';
    let sitelang_redirect_language = getCookieValue('sitelang_redirect_language').toString();
    if (sitelang_redirected_value) {
        localStorage.setItem('sitelang-redirected', true);
    }
    if (sitelang_redirected_value || localStorage.getItem('sitelang-redirected')) {
        const destination = !!sitelang_redirect_language ? sitelang_redirect_language : localStorage.getItem('sitelang-r') ? localStorage.getItem('sitelang-r') : getCookieValue('_icl_visitor_lang_js').substring(0,2);
        if(removeSlash(location.protocol + '//' + location.host + location.pathname) !== removeSlash(document.querySelector("link[rel='alternate'][hreflang='" + destination +"']").getAttribute('href'))) {
            window.location.replace(document.querySelector("link[rel='alternate'][hreflang='" + destination +"']").getAttribute('href'))
        }
    }
});